const questions = [
    {
        id: "sex",
        question: "Welchen Geschlecht ordnen Sie Sich zu?",
        options: [
            { id: "1", label: "männlich" },
            { id: "2", label: "weiblich" },
            { id: "3", label: "divers" }
        ],
    },
    {
        id: "question1",
        question:
            "Sind Sie zurzeit berufstätig?\n(Bitte auch bei gegenwärtiger Krankschreibung beantworten)",
        options: [
            { id: "1", label: "ja, Vollzeit (6 Stunden/Tag und mehr)" },
            { id: "2", label: "ja, Teilzeit (3 bis unter 6 Stunden/Tag)" },
            { id: "3", label: "ja, Teilzeit (1 bis unter 3 Stunden/Tag)" },
            { id: "4", label: "ja, in Ausbildung" },
            { id: "5", label: "Hausfrau/-mann\n(Falls dies für Sie zutrifft, beachten Sie bei der Beantwortung der folgenden Fragen Ihre Tätigkeiten für Haushalt und Familie wie eine berufliche Tätigkeit.)" },
            { id: "6", label: "nein, arbeitslos", dateFollowupText: "Seit wann sind Sie arbeitslos?" },
            { id: "7", label: "nein, Zeitrente oder ruhendes Arbeitsverhältnis", dateFollowupText: "Bis wann befinden Sie sich in Zeitrente oder ruhendem Arbeitsverhältnis?" },
            { id: "8", label: "nein, dauerhaft berentet\n(Altersrente, Erwerbsunfähigkeit-, Erwerbsmiderungs- oder Berufunfähigkeitsrente)" },
        ],
    },
    {
        id: "question2",
        question: "Glauben Sie, dass Sie nach der Reha-Maßnahme wieder an Ihrem bisherigen Arbeitsplatz tätig sein können?",
        options: [
            { id: "1", label: "ja" },
            { id: "2", label: "nein" }
        ],
    },
    {
        id: "question3",
        question: "Erwägen Sie zurzeit, einen Antrag auf Frührente aus Gesundheitsgründen zu stellen?",
        options: [
            { id: "1", label: "ja" },
            { id: "2", label: "nein" }
        ],
    },
    {
        id: "question4",
        question: "Wie bald nach Abschluss der Reha-Maßnahme glauben Sie, Ihre berufliche Tätigkeit wieder aufzunehmen zu können?",
        options: [
            { id: "1", label: "innerhalb eines Monats" },
            { id: "2", label: "nach mehr als einem Monat" },
            { id: "3", label: "überhaupt nicht mehr" }
        ],
    },
];

export default questions;
